import i18n from '@/helper/i18n';

export default function formatSubStatus(value) {
  return i18n.te(`vouchers.subStatusOptions.${value}`)
    ? i18n.t(`vouchers.subStatusOptions.${value}`)
    : value;
}
